import { render } from "./CadastroTabelaPreco.vue?vue&type=template&id=324cc95a"
import script from "./CadastroTabelaPreco.vue?vue&type=script&lang=ts"
export * from "./CadastroTabelaPreco.vue?vue&type=script&lang=ts"
script.render = render

export default script